import axios from "axios";
import { redirectTo } from "../utils/function";

export const getInstance = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log(`found error in getInstance`, error);
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        localStorage.removeItem(`tokenBackoffice`);
        sessionStorage.removeItem(`tokenBackoffice`);
        // window.location.href = "/backoffice/login";
        redirectTo('/login')
      }

      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('tokenBackoffice');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  return instance;
};